export const environment = {
  production: true,
  baseUrl: 'https://portal-d.bosch.tech/api',
  boschNT: 'FNO8FE',
  authenticationURL: 'https://portal-d.bosch.tech/api',
  isRedirectEnabled: true,
};
